import React from 'react';
import { Table, Form } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { get, map } from 'lodash';
import moment from 'moment';
import { CLIENTS_TABLE_HEADERS_ARRAY } from '../../constants';
import { convertBytesToGigabytes } from '../../utils/common';

import './index.css';

const ClientsTable = ({
  headers,
  rows,
  changeSort,
  sort,
  selectedItems,
  selectItem,
  deselectItem,
  selectAllItems,
  deselectAllItems,
  sortMethodName,
  sortMethod,
  sortMethods,
  setSortMethod,
  setSortMethodName,
}) => {
  const handleSelection = (item, checked) => {
    if (checked) {
      selectItem(item);
    }
    else {
      deselectItem(item);
    }
  };

  const handleAllSelection = checked => {
    if (checked) {
      selectAllItems();
    }
    else {
      deselectAllItems();
    }
  };

  const formatters = (key, value) => {
    switch (key) {
      case 'datetimeOfFirstCommit':
      case 'datetimeOfSecondCommit':
      case 'datetimeOfLastCommit':
        if (moment(value).isValid()) {
          return moment(value).format('DD.MM.YYYY. HH:mm:ss');
        }
        return 'None';
      case 'workPapersDiskUsage':
      case 'svnFolderDiskUsage':
      case 'svnDbFolderDiskUsage':
      case 'repositoryDiskUsage':
      case 'htmlDiskUsage':
        return `${convertBytesToGigabytes(value, 100)} GB`;
      default:
        return value;
    }
  };

  return (
    <Table striped bordered hover className="fixed_headers_clients_table">
      <thead>
        <tr>
          <th key='checkbox'>
            <Form.Check
              className="checkbox"
              onClick={e => handleAllSelection(e.target.checked)}
            />
          </th>
          <th>#</th>
          {headers.map((header, i) => {
            if (get(sortMethods, CLIENTS_TABLE_HEADERS_ARRAY[i])) {
              const isSortingOn = sortMethodName === CLIENTS_TABLE_HEADERS_ARRAY[i];
              const sortingIcon = sort === "ascending" ? "arrow-down" : "arrow-up";
              const finalIcon = isSortingOn ? sortingIcon : "minus";

              return (<th key={CLIENTS_TABLE_HEADERS_ARRAY[i]}>
                {header} <FontAwesome
                  className="sortArrow"
                  onClick={() => {
                    changeSort();
                    setSortMethod(() => sortMethods[CLIENTS_TABLE_HEADERS_ARRAY[i]]);
                    setSortMethodName(CLIENTS_TABLE_HEADERS_ARRAY[i]);
                  }}
                  name={finalIcon}
                />
              </th>);
            }
            return <th key={CLIENTS_TABLE_HEADERS_ARRAY[i]}>{header}</th>
          })}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, idx) => (
          <tr key={row.name}>
            <td>
              <Form.Check
                className="checkbox"
                checked={!!selectedItems.find(selectedClient => selectedClient.name === row.name)}
                onChange={e => handleSelection(row, e.target.checked)}
              />
            </td>
            <td>{idx+1}</td>
            {
              map(row, (value, key) => (
                <td>
                  {formatters(key, value)}
                </td>
              ))
            }
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ClientsTable;
